import { motion } from "framer-motion";
import { MousePointerClick, Download, Home } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: MousePointerClick,
    title: "Pulsa Descargar",
    text: "Toca el botón de Android y la descarga empieza al momento.",
    testid: "step-download",
  },
  {
    num: "02",
    icon: Download,
    title: "Instala la app",
    text: "La descarga es gratuita y ocupa muy poco. En menos de un minuto la tienes.",
    testid: "step-install",
  },
  {
    num: "03",
    icon: Home,
    title: "Encuentra tu piso",
    text: "Explora pisos y casas en toda España y habla con nosotros por WhatsApp.",
    testid: "step-find",
  },
];

export default function Steps() {
  return (
    <section id="como-funciona" className="scroll-mt-24 bg-[#f7f4ee] py-20 dark:bg-[#0c1a29] sm:py-28" data-testid="steps-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[#0f766e] dark:text-[#14b8a6]">En 3 pasos</p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-[#12263a] dark:text-[#f7f4ee] sm:text-4xl">
            Descargar es muy fácil
          </h2>
          <p className="mt-4 text-base text-[#12263a]/65 dark:text-[#f7f4ee]/60 sm:text-lg">
            Sin registros, sin formularios y sin pagos. Así de simple.
          </p>
        </motion.div>

        <div className="relative mt-16 grid gap-12 sm:grid-cols-3 sm:gap-8">
          <div className="absolute left-8 right-8 top-9 hidden border-t-2 border-dashed border-[#0f766e]/25 dark:border-[#14b8a6]/25 sm:block" aria-hidden="true" />
          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="relative"
              data-testid={step.testid}
            >
              <div className="flex items-center gap-4">
                <span className="relative z-10 flex h-[4.5rem] w-[4.5rem] shrink-0 items-center justify-center rounded-3xl bg-[#0f766e] text-white shadow-[0_14px_30px_-10px_rgba(15,118,110,0.5)]">
                  <step.icon className="h-6 w-6" />
                </span>
                <span className="step-number font-serif text-6xl font-bold leading-none sm:text-7xl">{step.num}</span>
              </div>
              <h3 className="mt-6 font-serif text-xl font-semibold text-[#12263a] dark:text-[#f7f4ee]">{step.title}</h3>
              <p className="mt-2 max-w-xs text-sm leading-relaxed text-[#12263a]/60 dark:text-[#f7f4ee]/55">{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
